import classNames from 'classnames';
import { ReactNode } from 'react';
import { joinNames, joinStreetHouseNumber, joinZipCodeCity } from '../../../utils/address';
import { BaseAddress, CollectionPointAddressPart } from '../../../utils/checkoutState';
import { getAssetUrl } from '../../../utils/config';
import './style.scss';

const FormattedAddress = ({
  address,
  title,
  isCompact
}: {
  address: BaseAddress & CollectionPointAddressPart;
  title?: ReactNode;
  isCompact?: boolean;
}) => {
  const { additional, state, collectionPoint } = address;
  return (
    <dl className="formatted-address">
      {title}
      <dd className="formatted-address__names">{joinNames(address)}</dd>
      {collectionPoint && (
        <dd>
          <img
            src={getAssetUrl('delivery/collectionPointActive.svg')}
            style={{ height: 17, transform: 'translateY(3px)' }}
          />
          {collectionPoint.description}
        </dd>
      )}
      <div className={classNames({ 'formatted-address__compact': isCompact })}>
        {additional && <dd>{additional}</dd>}
        <dd>{joinStreetHouseNumber(address)}</dd>
        <dd>{joinZipCodeCity(address)}</dd>
        {state && <dd>{state}</dd>}
      </div>
    </dl>
  );
};

export default FormattedAddress;
